import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AuthGuard } from './core/guards/auth.guard';
import { UnauthGuard } from './core/guards/unauth.guard';

import { LoginComponent } from './pages/login/login.component';
import { NewPasswordComponent } from './pages/new-password/new-password.component';
import { ForgotPasswordComponent } from './pages/forgot-password/forgot-password.component';
import { NotFoundPageComponent } from './pages/not-found-page/not-found-page.component';

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'login',
  },
  {
    path: 'login',
    title: 'Inicio de sesión',
    component: LoginComponent,
    canActivate: [UnauthGuard],
  },
  {
    path: 'new-password',
    title: 'Nueva contraseña',
    component: NewPasswordComponent,
  },
  {
    path: 'forgot-password',
    title: 'Recuperar contraseña',
    component: ForgotPasswordComponent,
    canActivate: [UnauthGuard],
  },
  {
    path: 'bracelets',
    canActivate: [AuthGuard],
    canLoad: [AuthGuard],
    loadChildren: () =>
      import('./modules/bracelets/bracelets.module').then((m) => m.BraceletsModule),
  },
  {
    path: '**',
    pathMatch: 'full',
    redirectTo: 'not-found',
  },
  {
    path: 'not-found',
    component: NotFoundPageComponent,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
  providers: [AuthGuard],
})
export class AppRoutingModule {}
